module.exports = __webpack_public_path__ + "static/media/img_classifier_dark.769151a2.PNG";